<template>
  <div class="d-flex flex-column">
    <b-card-text
      v-if="title"
      class="mb-2"
    >
      <h4>{{ title }}</h4>
    </b-card-text>
    <b-form-checkbox
      v-if="showEnable"
      v-model="enable"
      name="summary-toggle"
      switch
      @input="changeEnable"
    >
      <p class="font-weight-bold">
        {{ $t(`pages.chatSettings.ticketEditor.enable.${enable}`) }}
      </p>
    </b-form-checkbox>
    <b-card-text>
      {{ desc }}
    </b-card-text>
    <div class="d-flex flex-row mb-2">
      <div class="flex-item--half mr-2">
        <div class="d-flex flex-column">
          <h5
            v-if="editorTitle"
            class="mb-1"
          >
            {{ editorTitle }}
          </h5>
          <div class="d-flex flex-row">
            <div class="flex-item-input mr-2">
              <b-form-textarea
                v-if="locale === 'en'"
                v-model="en"
                class="flex-item--full"
                rows="6"
                no-resize
                width="100px"
                @keydown="handleKeyDown"
              />
              <b-form-textarea
                v-else-if="locale === 'zh'"
                v-model="zh"
                class="flex-item--full"
                rows="6"
                no-resize
                @keydown="handleKeyDown"
              />
              <b-form-textarea
                v-else-if="locale === 'km'"
                v-model="km"
                class="flex-item--full"
                rows="6"
                no-resize
                @keydown="handleKeyDown"
              />
              <b-form-textarea
                v-else-if="locale === 'vi'"
                v-model="vi"
                class="flex-item--full"
                rows="6"
                no-resize
                @keydown="handleKeyDown"
              />
            </div>
            <div>
              <b-form-select
                v-model="locale"
                :options="locales"
                :style="{
                  minWidth: '72px',
                  width: 'auto',
                  maxWidth: '120px'
                }"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex flex-row" />
    </div>
    <div
      v-if="notifySend !== undefined"
      class="d-flex flex-row align-items-center mb-1"
    >
      <b-form-input
        v-model="notifySend"
        class="input--time mr-1"
        type="number"
        min="1"
        :state="isValidNotifySend ? null : false"
        @keydown="handleKeyDown"
        @input="validateTiming"
        @blur="handleBlur"
      />
      <div class="d-flex flex-column flex-grow-1">
        <span class="text-break responsive-text">{{
          $tc('notify_send_desc', notifySend, {
            second: notifySend || 1
          })
        }}</span>
        <small
          v-if="!isValidNotifySend"
          class="text-danger"
        >
          {{ $t('notify_time_error') }}
        </small>
      </div>
    </div>
    <div
      v-if="autoCloseResolve !== undefined"
      class="d-flex flex-row align-items-center mb-1"
    >
      <b-form-input
        v-model="autoCloseResolve"
        class="input--time mr-1"
        type="number"
        min="1"
        :state="isValidAutoClose ? null : false"
        @keydown="handleKeyDown"
        @input="validateTiming"
        @blur="handleBlur"
      />
      <span class="text-break flex-grow-1 responsive-text">{{
        $tc('auto_close_desc', autoCloseResolve, {
          minute: autoCloseResolve || 1
        })
      }}</span>
    </div>
    <div class="mt-2">
      <b-form-checkbox
        v-if="showEnable"
        v-model="isEnableAutoCloseChatAfterResolved"
        name="summary-toggle"
        switch
        @input="changeEnableAfterResolved"
      >
        <p class="font-weight-bold">
          {{ $t(`pages.chatSettings.ticketEditor.enable.${isEnableAutoCloseChatAfterResolved}`) }}
        </p>
      </b-form-checkbox>
      <b-card-text>
        {{ $t('pages.chatSettings.autoCloseAfterResolved') }}
      </b-card-text>
    </div>
  </div>
</template>

<script>
import {
  BCardText,
  BFormCheckbox,
  BFormInput,
  BFormSelect,
  BFormTextarea,
} from 'bootstrap-vue'
import { max } from 'lodash'
import _isEqual from 'lodash/isEqual'

export default {
  components: {
    BCardText,
    BFormCheckbox,
    BFormInput,
    BFormSelect,
    BFormTextarea,
  },
  props: {
    id: {
      type: String,
      default: '',
      required: false,
    },
    value: {
      type: Object,
      default() {
        return {
          notifySend: 0 || undefined,
          autoCloseResolve: 0 || undefined,
          enable: false,
          locales: {
            en: '',
            zh: '',
            km: '',
            vi: '',
          },
          isEnableAutoCloseChatAfterResolved: false,
        }
      },
    },
    // enableAutoCloseAfterResolve: {
    //   type: Boolean,
    //   default: false
    // },
    title: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      required: true,
    },
    editorTitle: {
      type: String | undefined,
      default: undefined,
      // required: true,
    },
    showEnable: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    locale: 'en',
    locales: [
      { value: 'en', text: 'English' },
      { value: 'zh', text: '中文' },
      { value: 'km', text: 'ខ្មែរ' },
      { value: 'vi', text: 'Tiếng Anh' },
    ],
    autoCloseResolve: undefined,
    notifySend: undefined,
    originValue: false,
    enable: false,
    isEnableAutoCloseChatAfterResolved: false,
    originValueAfterResolved: false,
    en: '',
    zh: '',
    km: '',
    vi: '',
    pressingCount: 0,
  }),

  computed: {
    mappedReturnValue() {
      let value = {
        enable: this.enable,
        isEnableAutoCloseChatAfterResolved: this.isEnableAutoCloseChatAfterResolved,
        locales: {
          en: this.en,
          zh: this.zh,
          km: this.km,
          vi: this.vi,
        },
      }
      // Only include valid values in the return value
      if (this.autoCloseResolve && this.isValidAutoClose) {
        value = { ...value, autoCloseResolve: this.autoCloseResolve }
      }
      if (this.notifySend && this.isValidNotifySend) {
        value = { ...value, notifySend: this.notifySend }
      }
      return value
    },
    isValidNotifySend() {
      if (!this.notifySend || !this.autoCloseResolve) return true
      return Number(this.notifySend) <= Number(this.autoCloseResolve) * 60
    },

    isValidAutoClose() {
      if (!this.autoCloseResolve) return true
      return (
        Number(this.autoCloseResolve)
          >= Math.ceil(Number(this.notifySend) / 60)
      )
    },
  },
  watch: {
    value: {
      handler(newValue) {
        if (!_isEqual(this.mappedReturnValue, newValue)) {
          this.mapLocalesToData()
        }
      },
      deep: true,
    },
    mappedReturnValue: {
      handler(newValue) {
        if (!_isEqual(this.value, newValue)) {
          this.$emit('input', newValue)
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.mapLocalesToData()
  },
  methods: {
    handleKeyDown() {
      let timeoutId = 0
      this.pressingCount += 1
      const currentPressingCount = this.pressingCount

      if (timeoutId >= 0) {
        clearTimeout(timeoutId)
      }
      timeoutId = setTimeout(() => {
        if (currentPressingCount === this.pressingCount) {
          const payload = { ...this.value, ...{ id: this.id } }
          this.$emit('update:textEditor', payload)
          this.pressingCount = 0
        }
      }, 3000)
    },
    changeEnable() {
      if (this.originValue == this.enable) {
        return
      }
      this.originValue = this.enable
      const payload = {
        enable: this.enable,
        id: this.id,
      }
      this.$emit('update:enable', payload)
    },
    changeEnableAfterResolved() {
      if (this.originValueAfterResolved == this.isEnableAutoCloseChatAfterResolved) {
        return
      }
      this.originValueAfterResolved = this.isEnableAutoCloseChatAfterResolved
      const payload = {
        isEnableAutoCloseChatAfterResolved: this.isEnableAutoCloseChatAfterResolved,
        id: this.id,
      }
      this.$emit('update:isEnableAutoCloseChatAfterResolved', payload)
    },
    mapLocalesToData() {
      const {
        enable, locales, autoCloseResolve, notifySend, isEnableAutoCloseChatAfterResolved,
      } = this.value
      if (autoCloseResolve) this.autoCloseResolve = autoCloseResolve
      if (notifySend) this.notifySend = notifySend

      this.enable = enable
      this.isEnableAutoCloseChatAfterResolved = isEnableAutoCloseChatAfterResolved
      this.originValue = enable
      this.originValueAfterResolved = isEnableAutoCloseChatAfterResolved
      this.en = this.value.locales.en
      this.zh = this.value.locales.zh
      this.km = this.value.locales.km
      this.vi = this.value.locales.vi
      console.log('this.value: ', this.en, locales)
    },
    validateTiming() {
      // Emit validation status
      this.$emit('validation', {
        isValid: this.isValidNotifySend && this.isValidAutoClose,
        notifySend: this.notifySend,
        autoCloseResolve: this.autoCloseResolve,
      })

      // Handle keydown and emit update after validation
      this.handleKeyDown()
    },
    handleBlur() {
      if (Number(this.notifySend || 0) <= 0) {
        this.notifySend = 1
      }
      if (Number(this.autoCloseResolve || 0) <= 0) {
        this.autoCloseResolve = 1
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .input--time {
    width: auto !important;
    max-width: 150px !important;
  }

  .text-editor {
  }

  .text-editor--en {
    display: inherit;
  }

  .text-editor--zh {
    display: none;
  }

  .text-editor--km {
    display: none;
  }

  .responsive-text {
    @media (min-width: 576px) {
      max-width: 300px;
    }
    @media (min-width: 1400px) {
      max-width: 500px;
    }
    @media (min-width: 1600px) {
      max-width: 1200px;
    }
  }
</style>
